<template>
  <BaseDialog :title="infoDialogConfig.title" :visible="infoDialogVisible" append-to-body width="800px" @close="close">
    <template slot="body">
      <el-form :model="form" :rules="rules" ref="form" label-width="150px" label-position="right">
        <el-row>
          <el-col :span="12">
            <el-form-item label="记录日期" prop="rq">
              <el-date-picker v-model="form.rq" type="date" editable placeholder="请输入日期" value-format="yyyy-MM-dd" style="width: 100%"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="图片" prop="fileList1">
              <card-upload v-model="form.fileList1" :limit="2" :disabled="disabled" accept=".png,.jpg" ref="uploadFile1"></card-upload>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </template>

    <span slot="footer" class="dialog-footer">
            <el-button @click="close">取 消</el-button>
            <el-button type="primary" @click="confirm" v-show="!disabled">确 定</el-button>
        </span>
  </BaseDialog>
</template>

<script>
export default {
  name: "infoDialog",
  props: {
    infoDialogConfig: {
      type: Object,
      default: () => {
      },
    },
    infoDialogVisible: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      form: {
        id: '',
        rq: '',
        tp: '',
        compId: JSON.parse(sessionStorage.getItem('user')).organId,
        compBh: '',
        compMc: '',
        compQyjm: '',
        batchNum: '',
        createTime: '',
        createUserId: '',
        createUserName: '',
        fileList1: [],
      },
      rules: {
        fileList1: [{
          required: true,
          message: "请上传每日图片",
          trigger: "submit",
        },],
        rq: [{
          required: true,
          message: "请选择记录日期",
          trigger: "submit",
        },],
      },
      options: [],
      dialogVisible: false,
      disabled:false,
      //企业名称
      compList: [],
      //出栏原因
      slauClyyList: [],
      //是否已写入
      slauSfyxrList: [],
    };
  },
  computed: {},
  mounted() {
    this.slauClyyList = this.infoDialogConfig.slauClyyList;
    this.slauSfyxrList = this.infoDialogConfig.slauSfyxrList;
    this.compList = this.infoDialogConfig.compList;
    this.form.compId = this.compList[0].compId;
    this.form.compBh = this.compList[0].compBh;
    this.form.compMc = this.compList[0].compMc;
    this.form.compQyjm = this.compList[0].compQyjm;
    this.form.batchNum = this.infoDialogConfig.batchNum;
    if (this.infoDialogConfig.data) {
      for (const key in this.infoDialogConfig.data) {
        for (const k in this.form) {
          if (key === k) {
            this.form[k] = this.infoDialogConfig.data[key];
          }
        }
      }
      if (this.form.tp) {
        let tp = this.form.tp.split(",");
        tp.map(item => {
          this.form.fileList1.push({
            fileId: item
          });
        })
      }
    }
    if (!this.form.rq){
      this.form.rq = this.getNowDate();
    }
    this.disabled = this.infoDialogConfig.disabled;
  },

  methods: {
    //获取当前日期
    getNowDate() {
      var time = new Date();
      var day = ("0" + time.getDate()).slice(-2);
      var month = ("0" + (time.getMonth() + 1)).slice(-2);
      var today = time.getFullYear() + "-" + month + "-" + day;
      return today;
    },

    close() {
      this.$emit("update:infoDialogVisible", false);
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.form));
          if (this.form.fileList1.length > 0) {
            let tp = [];
            this.form.fileList1.map(item => {
              tp.push(item.fileId);
            })
            params.tp = tp.join(",");
          } else {
            params.tp = '';
          }
          delete params.fileList1;
          if (params.id) {
            this.$api
              .formPost("/api/major/tdb/everyPic/doModById", params)
              .then((res) => {
                this.$message.success("操作成功");
                this.close();
                this.$emit("onSuccess");
              });
          } else {
            delete params.id;
            this.$api
              .formPost("/api/major/tdb/everyPic/doSave", params)
              .then((res) => {
                this.$message.success("操作成功");
                this.close();
                this.$emit("onSuccess");
              });
          }
        }
      });
    },

  },
};
</script>

<style lang="scss" scoped>
.userInfo {
  width: 240px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .info {
    font-size: var(--text-size);
    display: flex;
    justify-content: space-between;
    padding: 13px 0px;
    border-bottom: 1px solid #ccc;

    .title {
      min-width: 70px;
    }
  }
}

.avatar-uploader {
  width: 100%;
  border: 1px dotted #ccc;
  text-align: center;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 240px;
  height: 240px;
  line-height: 240px;
  text-align: center;
}

.avatar {
  width: 240px;
  height: 240px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/everyDay/components/infoDialog.vue